module.exports = __webpack_public_path__ + "media/images/review/star_0-e28636f8e72df59a7f0ba542b7c73b0c.svg";